export default __webpack_public_path__ + "static/media/ELECTIVE__FREE_CHOICE.3f9fa413.png";